import { render } from "./StockExitModal.vue?vue&type=template&id=85b2e776&ts=true"
import script from "./StockExitModal.vue?vue&type=script&lang=ts"
export * from "./StockExitModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__